<template>
  <div class="pwd-login">

    <header class="h-font">
      <span @click="handleIsShowCode">
        <img src="@/assets/img/login/code.png" alt="">
      </span>
      <span>Hi，欢迎登录中智薪税云</span>
    </header>

    <el-form v-if="changeForm" class="login-form" status-icon :rules="loginRules" ref="loginForm" :model="loginForm">
      <el-form-item prop="username" class="item-user-password">
        <span slot="label">
          <span class="span-box">
              <img src="@/assets/img/login/icon_user.png" class="label-img-icon" alt="">
            <!-- <i class="el-icon-user" /> -->
              <span> 用户名 </span>
          </span>
        </span>
        <el-input size="medium" @keyup.enter.native="handleLogin" @change="getCus"  v-model="loginForm.username" debounce="0" auto-complete="off" :placeholder="$t('logon.iptAccount')">
          <!-- <svg slot="prefix" class="icon" style="margin-top: 9px" aria-hidden="true">
            <use xlink:href="#icon-yonghu"></use>
          </svg> -->
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="item-user-password">
        <span slot="label">
          <span class="span-box">
              <img src="@/assets/img/login/icon_key.png" class="label-img-icon" alt="">
            <!-- <i class="el-icon-lock" /> -->
              <span> 密码 </span>
          </span>
        </span>
        <el-input size="medium" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" auto-complete="off" :placeholder="$t('logon.iptPassword')">
          <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
          <!-- <svg slot="prefix" class="icon" style="margin-top: 9px" aria-hidden="true">
            <use xlink:href="#icon-mima"></use>
          </svg> -->
        </el-input>
      </el-form-item>
      <el-form-item prop="cus" v-if="cusList.length>1">
        <el-select  v-model="loginForm.cusId" :placeholder="$t('logon.selectCustomer')" v-show="this.cusList.length>0" @change="pickCusId">
          <el-option
            v-for="item in cusList"
            :key="item.uid"
            :label="item.cname"
            :value="item.uid">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="code" style="text-align: left;" class="item-code" v-show="this.loginForm.loginType=='2'">
        <el-input size="medium" @keyup.enter.native="handleLogin" v-model="loginForm.code" auto-complete="off" :placeholder="$t('logon.iptCheckcode')">
          <!-- <svg slot="prefix" class="icon" style="margin-top: 9px;" aria-hidden="true">
            <use xlink:href="#icon-yonghu"></use>
          </svg> -->
        </el-input>
        <el-image
          :src="codeImg.src"
          :fit="scale-down" @click="refreshCode"></el-image>
      </el-form-item>
      <el-form-item class="login-button-item">
        <el-button type="primary" :loading="loginLoading" size="medium" @click.native.prevent="handleLogin" class="login-submit">{{$t("logon.login")}}</el-button>
      </el-form-item>
      <el-form-item>
        <div class="forgetItem">
          <el-link type="primary" @click="changeLaguages">{{lang}}</el-link>
          <el-row>
            <el-link type="primary" @click="handleResetPwd" style="margin-right:34px">{{$t("logon.forgetPassword"/**忘记密码*/)}}</el-link>
            <el-link type="primary" @click="handleReister">{{$t("logon.register"/**注册*/)}}</el-link>
          </el-row>
        </div>
      </el-form-item>
    </el-form>
    <section class="cui-s-code" v-else>
      <img :src="`data:image/png;base64,${codeImgSrc}`"/>
    </section>
  </div>
</template>

<script>
  import { randomLenNum,guid,encrypt, decrypt } from '@/util/util';
  import hrCommon from '@/api/common/hrcloudCommon';
  import {base64Encode, base64Decode} from '@/util/endecode.js';
  import { getCusList, produceQrCode, wcLogin } from '@/api/user/login';
  import store from '@/store';
  import { mapGetters } from 'vuex';
  const hrPrefix = '/hrcloud'
  export default {
    name: 'pwdlogin',
    data() {
      const validateCode = (rule, value, callback) => {
        if (this.codeImg.value != value) {
          this.loginForm.code = '';
          this.refreshCode();
          callback(new Error(this.$t('logon.iptTrueCheckcode')));
        } else {
          callback();
        }
      };
      return {
        checked: true,
        lang:'En',
        changeForm:true,
        loginForm: {
          username: '',
          password: '',
          cusId: '',
          branchId: '',
          code: '',
          randomStr: '',
          loginType: '1', // 是否需要验证码，默认第一次登陆时是不需要验证码的，密码输入错误后，需要输入验证码
          codeKey: ''
        },
        codeImg: {
          // src: '/user/code',
          src: '',
          value: '',
          len: 4,
          type: 'image',
        },
        loginLoading: false,
        loginRules: {
          username: [
            { required: true, message: this.$t('logon.iptAccount'), trigger: 'blur' },
          ],
          password: [
            { required: true, message: this.$t('logon.iptPassword'), trigger: 'blur' },
            { min: 6, message: this.$t('logon.iptPasswordLen'), trigger: 'blur' },
          ]
        },
        passwordType: 'password',
        cusList:[],
        codeImgSrc: '', // code base64
      };
    },
    created() {
      // console.log(process.env.VUE_APP_LOCAL_DEVELOPMENT)
      this.refreshCode();
      if(this.loginForm.username!=""){
        this.getCus();
      }
      //语言设置
      var lang = localStorage.getItem('lang');
      if(lang){
        this.lang = (lang==='zh')?'En':'中';
        this.$i18n.locale = lang;
      }
    },
    mounted() {},
    computed: {
    },
    props: ['loginMethod'],
    methods: {
      //选择客户改变
      pickCusId: function (selVal) {
        this.loginForm.cusId= selVal;
        for(let i=0;i<this.cusList.length;i++){
          if(this.cusList[i].uid==selVal){
            this.loginForm.branchId= this.cusList[i].branchId;
            break;
          }
        }
      },
      changeLaguages () {
        console.log(this.$i18n.locale);
        let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
        this.$i18n.locale = lang;
        localStorage.setItem('lang',lang);
        this.$store.commit('CHANGE_LANG', lang)
        if(lang==='zh'){
          this.lang = 'En';
        }else{
          this.lang = '中';
        }
        //此处主要是翻译语言
        this.loginRules = {
          username: [
            { required: true, message: this.$t('logon.iptAccount'), trigger: 'blur' },
          ],
          password: [
            { required: true, message: this.$t('logon.iptPassword'), trigger: 'blur' },
            { min: 6, message: this.$t('logon.iptPasswordLen'), trigger: 'blur' },
          ]
        }
      },
      changMethod(){
        this.$emit('update:loginMethod', 'code')
      },
      refreshCode() {
        this.loginForm.code = '';
        this.loginForm.codeKey = guid();
        this.loginForm.randomStr = randomLenNum(this.codeImg.len, true);
        this.codeImg.type == 'text'
          ? (this.codeImg.value = randomLenNum(this.codeImg.len))
          : (this.codeImg.src = `${hrCommon.HRCLOUD_URL}util/getVerifyCodeNew.action?codeKey=`+base64Encode(this.loginForm.codeKey)); //调用人事云接口获取 验证码
      },
      showPassword() {
        this.passwordType == ''
          ? (this.passwordType = 'password')
          : (this.passwordType = '');
      },
      getCus(){
          if(this.loginForm.username===''){
            this.cusList = [];
            return;
          }
          getCusList(this.loginForm.username).then(res => {
              let resDes= JSON.parse(decrypt(res.data));
              this.loginForm.cusId = "";
              this.cusList = [];
              if(200==resDes.statusCode){
                  let dres = decrypt(resDes.data, '');
                  this.cusList = JSON.parse(dres);
                  if(this.cusList.length>1){
                    return;
                  }else if(this.cusList.length == 1 ){
                    this.loginForm.cusId = this.cusList[0].uid;
                    this.loginForm.branchId = this.cusList[0].branchId;
                  }
              }else{
                  this.loginLoading = false;
                  this.$message.error(resDes.msg);
                  return;
              }
          });
      },
      handleLogin() {
        //当username缓存的有值获取不到cusId时处理：
        if(this.loginForm.username && !this.loginForm.cusId){
          this.getCus();
          setTimeout( ()=> {
            this.validate();
        },500)
        }else{
          this.validate();
        }

      },
      //校验登录分离公共方法
      validate(){
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loginLoading = true;
            // console.log(/^\d+$/.test(this.loginForm.username))
            if(/^\d+$/.test(this.loginForm.username)){
              //手机号
              this.loginForm.type = 2
            }else if(this.loginForm.username.indexOf("@") != -1){
              //邮箱
              this.loginForm.type = 3
            }else{
              //用户名
              this.loginForm.type = 1
              this.loginForm.username = this.loginForm.username
            }
            this.$store.dispatch('LoginByUsername', this.loginForm).then(
              (res) => {
              console.log(res);
            if(!res.data.success){
              this.loginLoading = false;
              this.$message.error(res.data.msg);
              this.loginRules.code = [
                { required: true, message:this.$t('logon.iptCheckcode'), trigger: 'blur' },
                { min: 4, max: 4, message: this.$t('logon.iptCheckcodeLen'), trigger: 'blur' },
              ];
              this.loginForm.loginType = '2';
              this.refreshCode();
            } else {
              let userType = res.data.data.userType;
              let cusSourceType = res.data.data.cusSourceType;//0 老系统 1新系统
              if("10620003"!=userType){ //当为HR时
                if("1"==cusSourceType){
                  this.$router.push({path: '/index'});
                  this.$message.success('登录成功');
                }else{
                  let hrUrl = hrCommon.HRCLOUD_URL+"secondMain.action?accessToken="+base64Encode(encrypt(store.getters.accessToken,''));
                  console.log(hrUrl);
                  window.location.href = hrUrl;
                }
              }else{ //雇员时，跳转到雇员端页面
                let empUrl = hrCommon.HRCLOUD_URL+"emp/index.action?accessToken="+base64Encode(encrypt(store.getters.accessToken,''));
                console.log(empUrl);
                window.location.href = empUrl;
              }

            }
          }
          ).catch(
              (error) => {
              this.loginLoading = false;
            if(error.data && error.data.msg){
              this.$message.error(error.data.msg);
            }
            this.loginRules.code = [
              { required: true, message:this.$t('logon.iptCheckcode'), trigger: 'blur' },
              { min: 4, max: 4, message: this.$t('logon.iptCheckcodeLen'), trigger: 'blur' },
            ];
            this.loginForm.loginType = '2';
            this.refreshCode();
          })
          }
        });
      },
      //忘记密码页面
      handleResetPwd:function(){
        let lang = localStorage.getItem('lang');
        let param = "";
        if(lang){
          param="?lang="+base64Encode(lang)
        }
        var hrcloudPath = hrCommon.HRCLOUD_URL+"accountConfirmation.action"+param;
        window.open(hrcloudPath,"_blank")
      },
      //注册页面
      handleReister:function(){
        let lang = localStorage.getItem('lang');
        let param = "";
        if(lang){
          param="?lang="+base64Encode(lang)
        }
        var hrcloudPath = hrCommon.HRCLOUD_URL+"toRegister.action"+param;
        window.open(hrcloudPath,"_blank")
      },
      // 是否显示code码
      handleIsShowCode() {
        this.changeForm = !this.changeForm
        if (!this.changeForm) {
          produceQrCode().then(res => {
            if (res.data.msg === 'success') {
            this.codeImgSrc = res.data.data
          }
        })
        }

        if (this.changeForm) { return }

        console.log("🚀 ~ file: pwdlogin.vue ~ line 349 ~ handleIsShowCode ~ process.env.VUE_APP_BASE_URL", process.env.VUE_APP_BASE_URL)
        var ws = new WebSocket("ws://2333e85t52.zicp.vip/chartServer/login");

        ws.onopen = (evt) => {
          console.log("Connection open ...");
          ws.send("Hello WebSockets!");
        };

        ws.onmessage = (evt) => {
          ws.close();

          console.log( "Received Message: " + evt.data);
          if (evt.data.code == 0) {
            let params = {
              wxCode: evt.data.wxCode,
              state: evt.data.state
            }
            wcLogin(params).then(res => {

            })

          } else {
            this.$message(evt.data.msg);
            this.changeForm = true
          }
        };

        ws.onclose = function(evt) {
          console.log("Connection closed.");
        };

      },


    },
  };
</script>

<style lang="scss" scoped>
  .pwd-login {
  .el-button {
    font-size: 0.24rem;
  }

  /**header */
  .h-font {
    width: 100%;
  span {
    display: block;
    font-size: 0.26rem;
    text-align: left;
  }
  span:first-child {
    text-align: right;
    margin: 0.10rem 0.10rem 0 0;
    cursor: pointer;
  img {
    display: inline-block;
    width: 0.49rem;
    height: 0.50rem;
  }
  }
  span:last-child {
    margin-top: -0.30rem;
    margin-left: 0.34rem;
    margin-bottom: 0.42rem;
    font-weight: 600;
    color: #333333;
  }

  }

  .login-form {
    padding: 0 0.34rem;
  }

  /**用户密码 */
  .item-user-password {
    width: 4.43rem;
    margin: 0 auto;
    margin-bottom: 0.30rem;
  .span-box {
    display: inline-block;
    font-size: 0.24rem;
    color: #999999;
    margin-bottom: 0.12rem;
  .label-img-icon {
    display: inline-block;
    width: 0.20rem;
    margin-top: -0.02rem;
    vertical-align: middle;
  }
  }
  &::v-deep .el-input--medium .el-input__inner {
     height: 0.60rem;
     border-radius: 0.44rem;
     border: 1px solid rgba(57, 63, 108, 0.59);
   }
  }

  /** 按钮 */
  .login-button-item {
    width: 100%;
    text-align: center;
  &::v-deep .el-button--medium{
     width: 1.91rem;
     height: 0.60rem;
     background: #393F6C;
     border-radius: 0.44rem;
     border: none;
   }
  }

  /** 下拉多选 */
  &::v-deep .el-select .el-input__inner {
     height: 0.6rem;
     border-radius: 0.44rem;
     border: 1px solid rgba(57, 63, 108, 0.59);
     font-size: 0.24rem;
     font-weight: 400;
   }

  /** 验证码 */
  .item-code {
    margin-top: -0.10rem;
  &::v-deep .el-input--medium {width: 2.45rem;}
  &::v-deep .el-input--medium .el-input__inner {
     height: 0.60rem;
     border-radius: 0.44rem;
     border: 1px solid rgba(57, 63, 108, 0.59);
     font-size: 0.24rem;
     font-weight: 400;
     text-align: center;
   }
  &::v-deep .el-image {
     width: 1.48rem;
     height: 0.46rem;
     float: right;
     margin-top: 0.07rem;
   }
  }

  /**en 注册 忘记密码 */
  .forgetItem {
    margin-bottom: 0.11rem;
    display: flex;
    justify-content: space-between;
  &::v-deep .el-link.el-link--primary{
     font-size: 0.18rem;
     color: #014897;
     text-decoration:underline
   }
  }

  &::v-deep .icon,.login-form .el-input__icon{
     color: rgba(1, 72, 151, 0.5);
   }


  // 二维码图片
     .cui-s-code {
       text-align: center;
  padding: 0 0.30rem
                 img {
                   display: inline-block;
                 // width: 100%;
                 }
  }
  }

</style>
